import React, { useEffect, useState, useMemo } from 'react';
import { Button, CircularProgress } from "@mui/material";
import UserCard from "./userCard";
import Box from "@mui/material/Box";
import {sortBy} from 'lodash';
import { Link } from 'react-router-dom';

function FixedEquipe(props) {
  return (
    <div className="fixed_equipe" ><h3>Equipe</h3></div>
  )
}

const Equipe = () => {
  const baseUrl = process.env.REACT_APP_API_URL || window.location.origin;
  const url = useMemo(() => `${baseUrl}/content/equipe`, [baseUrl]);
  const requestHeaders = useMemo(() => {
    const headers = new Headers();
    headers.append("X-Frontend-Client", "react-app");
    return headers;
  }, []);

  const [users, setUsers] = useState([]);
  const [isLoading, setLoading] = useState(false);
  
  useEffect(() => {
    document.title = 'Modular - ATHIS: Equipe';

    const fetchData = () => {
      setLoading(true);
      fetch(url, {
      method: 'GET',
      headers: requestHeaders
      })
        .then((response) => response.json())
        .then((result) => {
          setUsers(result);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    }
    fetchData();
  }, [url, requestHeaders]);
  if (isLoading) {
    return <CircularProgress className="loading" />;
  }
return (<div>
  <Box className="equipe maincontent">
  <FixedEquipe />
<ul className="cards" sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
    {
      sortBy(users, ['primeiro_nome']).map(user => (
      <UserCard user={user} name={user.email.split("@")[0]} location="equipe" key={user.id}/>))
    }
  </ul>
  <div className="voluntariado_button_container">
    <Link to="https://forms.cloud.microsoft/r/pDehqPi7Hg" target="_blank"><Button variant="outlined" className="voluntariado_button">Seja uma pessoa Voluntária</Button></Link>
  </div>
  </Box>
  </div>
)
};

export default Equipe;